import { useDispatch } from "react-redux";
import { Box, Text } from "theme-ui";
import nl2br from "react-nl2br";

import { dismissNotification } from "store/app/appSlice";
import { CloseButton } from "components";
import { InfoIcon } from "components/icons";
import * as styles from "./notifications.styles";

function NotificationIcon({ icon }) {
  switch (icon) {
    case "InfoIcon":
      return <InfoIcon />;

    default:
      return null;
  }
}

function Notification({ id, notificationType, content, icon, canClose }) {
  const dispatch = useDispatch();

  const handleCloseClick = () => {
    dispatch(dismissNotification(id));
  };

  return (
    <Box
      sx={styles.notification({
        notificationType,
        hasIcon: Boolean(icon),
        hasCloseButton: canClose,
      })}
    >
      {icon && <NotificationIcon icon={icon} />}
      <Text>{nl2br(content)}</Text>
      {canClose && (
        <CloseButton onClick={handleCloseClick} sx={styles.closeButton} />
      )}
    </Box>
  );
}

export default function Notifcations({ notifications = [], canClose = false }) {
  return (
    <Box sx={styles.notifications}>
      {notifications.map((notification) => (
        <Notification
          key={notification.id}
          {...notification}
          canClose={canClose}
        />
      ))}
    </Box>
  );
}
